import React, { useState, useEffect } from 'react';
import { Modal, Input, Descriptions, Button, Form, Space, Select, message } from 'antd';
import { MinusOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { updateProjectDetails,deleteProjectTask } from '../../webServices/Apis'; // Import the API function

const { Option } = Select;

const ProjectModal = ({ isOpen, onClose, project, isEditMode, onSave }) => {
  const [form] = Form.useForm();
  const [editableProject, setEditableProject] = useState({
    projectName: '',
    projectDescription: '',
    status: '',
    tasks: [],
  });

  useEffect(() => {
    if (project) {
      setEditableProject(project);
      form.setFieldsValue(project); // Set initial form values if editing
    }
  }, [project, form]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableProject({
      ...editableProject,
      [name]: value,
    });
  };

  const handleStatusChange = (value) => {
    setEditableProject({
      ...editableProject,
      status: value,
    });
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const updatedProject = { ...editableProject, ...values };
        updateProjectDetails(updatedProject) // Call the API to update the project
          .then((res) => {
message.success(res.data.message)
            
           onSave(updatedProject); // Update the parent component
             onClose(); // Close the modal after saving
            return;
          })
          .catch((error) => {
            console.error('Error updating project:', error);
          });
      })
      .catch((info) => {
        console.error('Validation failed:', info);
      });
  };

  const addTask = () => {
    setEditableProject({
      ...editableProject,
      tasks: [...editableProject.tasks, { task: '', isNew: true }], 
    });
  };

  const removeTask = (index) => {
    const newTasks = editableProject.tasks.filter((_, idx) => idx !== index);
    setEditableProject({ ...editableProject, tasks: newTasks });
  };

  const handleTaskChange = (index, value) => {
    const newTasks = [...editableProject.tasks];
    newTasks[index].task = value; // Update task property
    setEditableProject({ ...editableProject, tasks: newTasks });
  };



  const handleDeleteProjectTask = async (id) => {
    try {
      const res = await deleteProjectTask(id);
      if (res.data.success) {
        message.success("Task deleted SuccessFully")
      }
    } catch (error) {
      message.error(error.response.data.message)
    }
  }

  return (
    <Modal
      title={isEditMode ? 'Edit Project' : 'Project Details'}
      visible={isOpen}
      onCancel={onClose}
      footer={
        isEditMode ? (
          <>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={handleSave}>
              Save
            </Button>
          </>
        ) : null
      }
    >
      <Form form={form} layout="vertical">
        {isEditMode ? (
          <>
            <Form.Item
              label="Project Name"
              name="projectName"
              rules={[{ required: true, message: 'Please enter the project name' }]}
            >
              <Input
                name="projectName"
                value={editableProject.projectName}
                onChange={handleInputChange}
              />
            </Form.Item>

            <Form.Item
              label="Project Description"
              name="projectDescription"
              rules={[{ required: true, message: 'Please enter the project description' }]}
            >
              <Input.TextArea
                name="projectDescription"
                value={editableProject.projectDescription}
                onChange={handleInputChange}
              />
            </Form.Item>

            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: 'Please select the project status' }]}
            >
              <Select
                value={editableProject.status}
                onChange={handleStatusChange}
                style={{ width: '100%' }}
              >
                <Option value="In Progress">In Progress</Option>
                <Option value="Completed">Completed</Option>
                <Option value="Pending">Pending</Option>
                <Option value="On Hold">On Hold</Option>
              </Select>
            </Form.Item>

            {/* Tasks Section */}
            <Form.Item label="Tasks">
              {editableProject.tasks.map((task, index) => (
                <Space key={index} style={{ display: 'flex', marginBottom: 8 }} align="start">
                  <Input
                    placeholder="Task"
                    value={task.task}
                    onChange={(e) => handleTaskChange(index, e.target.value)}
                  />
                  {/* Show delete icon for all tasks */}
                  {task.id ? (
                    <DeleteOutlined
                      onClick={() => {
                        handleDeleteProjectTask(task.id);
                        removeTask(index);
                      }}
                    />
                  ) : (
                    task.isNew && (
                      <MinusOutlined onClick={() => removeTask(index)} />
                    )
                  )}
                </Space>
              ))}
              {/* Show Add Task button */}
              <Button type="dashed" onClick={addTask} block icon={<PlusOutlined />}>
                Add Task
              </Button>
            </Form.Item>
          </>
        ) : (
          <Descriptions bordered>
            <Descriptions.Item label="Project Name" span={3}>
              {project?.projectName || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Project Description" span={3}>
              {project?.projectDescription || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Status" span={3}>
              {project?.status || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Tasks" span={3}>
              {project?.tasks && project.tasks.length > 0 ? (
                <ul>
                  {project.tasks.map((task, index) => (
                    <li key={index}>{task.task}</li>
                  ))}
                </ul>
              ) : (
                'No tasks available'
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Form>
    </Modal>
  );
};

export default ProjectModal;
